module.exports = __webpack_public_path__ + "img/banner5.d35b5ad2.jpg";